module.exports = __webpack_public_path__ + "img/video2-bg.050dfde4.png";